import { ReactElement } from 'react'
import LoginForm from '../../forms/login-form'
import { Flexbox } from '../../components/flexbox/flexbox'
import Logo from '../../components/logo/logo'

export const LoginScreen = (): ReactElement => {
  return (
    <Flexbox justifyContent="center" alignItems="center" flex={1}>
      <Flexbox direction="column" justifyContent="center" alignItems="center">
        <Logo size={230} />
        <LoginForm />
      </Flexbox>
    </Flexbox>
  )
}